import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import { Circle } from '@bubble-ui/primitive-circle';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import RadialGradient from '@bubble-ui/primitive-radial-gradient';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationRawMaterialProcessing = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationRawMaterialProcessing',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_5601_1354)",
    d: "M20 23h68a4 4 0 0 1 4 4v68a4 4 0 0 1-4 4H24a4 4 0 0 1-4-4V23Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_5601_1354)",
    d: "M20 15h58a4 4 0 0 1 4 4v68a4 4 0 0 1-4 4H20V15Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint2_linear_5601_1354)",
    d: "M8 14C8 6.82 13.82 1 21 1s13 5.82 13 13v64c0 7.18-5.82 13-13 13S8 85.18 8 78V14Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint3_linear_5601_1354)",
    fillOpacity: 0.2,
    d: "M21 1c7.732 0 14 6.268 14 14v62c0 7.732-6.268 14-14 14V1Z"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 21,
    cy: 78,
    r: 10,
    fill: "#D2B6FF"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 21,
    cy: 78,
    r: 7,
    fill: "#2A44C6"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 21,
    cy: 78,
    r: 11.5,
    stroke: "url(#paint4_radial_5601_1354)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D2B6FF",
    d: "M62 15h4v76h-4zM70 15h4v76h-4z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_5601_1354",
    x1: 92,
    x2: 20,
    y1: 23,
    y2: 99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#D2B6FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#2A44C6"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_5601_1354",
    x1: 28,
    x2: 82,
    y1: 53,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#2A44C6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#EBC5FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear_5601_1354",
    x1: 8,
    x2: 34,
    y1: 51,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#EDC6FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#5A6CFF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint3_linear_5601_1354",
    x1: 8,
    x2: 34,
    y1: 51,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#2A44C6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#5A6CFF",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement(RadialGradient, {
    id: "paint4_radial_5601_1354",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(12 -10 10 12 21 78)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#2A44C6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#2A44C6",
    stopOpacity: 0
  }))));
};
ColoredIllustrationRawMaterialProcessing.displayName = 'ColoredIllustrationRawMaterialProcessing';
export default withProvisionalOverrideFromContext(ColoredIllustrationRawMaterialProcessing);
//# sourceMappingURL=index.js.map